import "react-app-polyfill/ie9";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import {
  applyPolyfills,
  defineCustomElements,
} from "@meios-pagamentos/eldorado-bridge-component/loader";

import { ThemeProvider } from "styled-components";
import App from "./components/App";
import ErrorBoundary from "./components/ErrorBoundary";
import history from "./history";
import store from "./store";
import { initMonitoring } from "./monitoring";

import { STYLES, GlobalFonts, GlobalStyle } from "./styles/_utilities";
import "./index.scss";

initMonitoring();

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={STYLES}>
      <ErrorBoundary>
        <App history={history} />
      </ErrorBoundary>
      <GlobalFonts />
      <GlobalStyle />
    </ThemeProvider>
  </Provider>,
  document.getElementById("app-root")
);

applyPolyfills().then(() => {
  defineCustomElements();
});
